import React from "react";
import FaqHome from "components/molecules/FaqHome";

const Faq = () => {
	return (
		<div className="container mx-auto">
			<div className="mt-[100px] md:mt-[181px]">
				<FaqHome />
			</div>
		</div>
	);
};

export default Faq;
